export default {
  body: `
    ¿Cómo puede proteger su salud la vacuna contra el coronavirus?
  `,
  topic: `
    Cómo puede proteger mi salud la vacuna contra el coronavirus.
  `,
};
